import { render, staticRenderFns } from "./viewForm.vue?vue&type=template&id=98f3fac8&"
import script from "./viewForm.vue?vue&type=script&lang=js&"
export * from "./viewForm.vue?vue&type=script&lang=js&"
import style0 from "./viewForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports